import styled from 'styled-components';

export const CompetitorContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
  overflow: hidden;
`;

export const CompetitorTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
`;

export const CompetitorContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background: #fff;
  border-radius: 0 0 8px 8px;
  padding: 12px 0;
  overflow-y: auto;
  min-height: 0;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 10px;
    transition: background 0.2s ease;
  }

  &:hover {
    &::-webkit-scrollbar-thumb {
      background: rgba(108, 117, 125, 0.6);
    }

    &::-webkit-scrollbar-thumb:hover {
      background: rgba(108, 117, 125, 0.8);
    }
  }

  scrollbar-width: thin;
  scrollbar-color: transparent transparent;

  &:hover {
    scrollbar-color: rgba(108, 117, 125, 0.6) transparent;
  }
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: auto;
  justify-items: center;

  @media (max-width: 1400px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
`;

export const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  font-size: 16px;
  color: #666;
`;

export const EmptyState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  font-size: 16px;
  color: #999;
`;
